export default __webpack_public_path__ + "static/media/checkinbutton.f6234e66.png";